import posthog from "posthog-js";

const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY;
const POSTHOG_HOST =
  process.env.REACT_APP_POSTHOG_HOST || "https://eu.i.posthog.com";

const isEnabled = () =>
  process.env.NODE_ENV !== "development" && Boolean(POSTHOG_KEY);

let initialized = false;

export const initPostHog = () => {
  if (initialized || !isEnabled()) return;
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    capture_pageview: false,
    autocapture: false,
    capture_exceptions: true,
    disable_session_recording: true,
    session_recording: {
      maskAllInputs: true,
      maskTextSelector: "[data-private]",
    },
  });
  initialized = true;

  if (typeof window !== "undefined") {
    window.addEventListener("error", () => ensureRecording());
    window.addEventListener("unhandledrejection", () => ensureRecording());
  }
};

let recordingStarted = false;
const ensureRecording = () => {
  if (recordingStarted) return;
  try {
    posthog.startSessionRecording();
    recordingStarted = true;
  } catch (_) {
    // ignore
  }
};

export const captureException = (error, context = {}) => {
  if (!isEnabled() || !initialized) return;
  try {
    ensureRecording();
    posthog.captureException(error, context);
  } catch (_) {
    // swallow — never let telemetry break the app
  }
};

export const identifyUser = ({ user_id, group_id, organisation_id } = {}) => {
  if (!isEnabled() || !initialized || !user_id) return;
  posthog.identify(user_id, { group_id, organisation_id });
};

export const resetPostHog = () => {
  if (!isEnabled() || !initialized) return;
  posthog.reset();
};

export { posthog };
